// extracted by mini-css-extract-plugin
module.exports = {"errorPageContainer":"web-signup__ErrorPage__errorPageContainer","errorPageButton":"web-signup__ErrorPage__errorPageButton"};